<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <h1 class="label-title">Thank you for creating an account with us.</h1>
    <h4>You may start using Check Plus.</h4>
    <button
      *ngIf="fromMobile == ''"
      (click)="navigateLogin()"
      class="buttons home-button"
      gbui-button
      type="submit"
    >
      Home
    </button>
    <a
      *ngIf="fromMobile == 'true' && returnUrl"
      [href]="returnUrl"
      target="_blank"
      rel="noopener noreferrer"
      (click)="clearStorage()"
      class="buttons"
      gbui-button
      style="text-decoration: none; display: flex; align-items: center; justify-content: center;"
    >
      Go to the App
    </a>
    <!-- <button
      *ngIf="fromMobile == 'true' && !returnUrl"
      (click)="backToTheApp()"
      class="buttons"
      gbui-button
      type="submit"
    >
      Go Back to the App
    </button> -->
  </div>
</div>
